import { inject, Injectable } from '@angular/core';
import { OptionsList } from 'gung-common';
import { PriceService } from 'gung-standard';
import { first, Observable, of, ReplaySubject } from 'rxjs';
import { HlDisplayPortalFeaturesService, ProductListInfoSettingsGroup } from './hl-display-portal-features.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayTemplatePortalService {
  protected priceService = inject(PriceService);
  protected hldisplayPortalFeaturesService = inject(HlDisplayPortalFeaturesService);
  protected translateService = inject(TranslateService);

  protected selectedTemplateAssortmentIdSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
  protected assortmentOptionsSubject: ReplaySubject<OptionsList[]> = new ReplaySubject<OptionsList[]>(1);

  public initSelectedTemplateAssortment(): void {
    this.hldisplayPortalFeaturesService
      .getPortalFeatureGroup('productListInfoSettingsGroup')
      .pipe(first())
      .subscribe((features: ProductListInfoSettingsGroup) => {
        if (features.templatePortal) {
          this.priceService
            .getPriceListOptions()
            .pipe(first())
            .subscribe(allPriceLists => {
              const filteredPriceLists = allPriceLists.filter(pl => features.templatePriceListIds?.includes(pl.id));

              const assortmentOptions: OptionsList[] =
                filteredPriceLists?.map(pl => {
                  return { id: `${pl.id}_TEMPLATE`, name: pl.name };
                }) || [];

              if (!!assortmentOptions.find(o => o.id === localStorage.getItem('SelectedTemplateAssortmentId'))) {
                this.setSelectedTemplateAssortmentId(localStorage.getItem('SelectedTemplateAssortmentId'));
              } else {
                this.setSelectedTemplateAssortmentId(!!assortmentOptions[0] ? assortmentOptions[0].id : '');
              }

              this.assortmentOptionsSubject.next(assortmentOptions);
            });
        } else {
          this.selectedTemplateAssortmentIdSubject.next('');
          this.assortmentOptionsSubject.next([]);
        }
      });
  }

  public getAssortmentOptions(): Observable<OptionsList[]> {
    return this.assortmentOptionsSubject.asObservable();
  }

  public getSelectedTemplateAssortmentId(): Observable<string> {
    return this.selectedTemplateAssortmentIdSubject.asObservable();
  }

  public setSelectedTemplateAssortmentId(assortmentId: string): void {
    this.selectedTemplateAssortmentIdSubject.next(assortmentId);
    localStorage.setItem('SelectedTemplateAssortmentId', assortmentId);
  }
}
